module.exports = __webpack_public_path__ + "static/media/jet-item-trasnparent.3af00d85.png";